/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-cycle */
import { FC, useContext } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import { IInformativeModalProps } from '../../../blades/informativeModal/@types';
import RichText from '../../RichText';
import Typo from '../../Typo';
import styles from './skillbuilderSubmissionPopUp.module.sass';
import utils, { logger } from '../../../utils';
import AuthContext from '../../../AppContext/AuthProvider';
import downloadIcon from '../../../../public/static/images/download-icon.svg';
import shareIcon from '../../../../public/static/images/share-icon-fill.svg';

const SkillbuilderSubmissionPopUp: FC<IInformativeModalProps> = props => {
  const { heading, description, footer, image } = props;
  const { appUser } = useContext(AuthContext);
  const imageSrc = `https:${image?.fields.file.url}`;
  const download = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetch(e.target.href, {
        method: 'GET',
        headers: {},
      });
      const buffer = await response.arrayBuffer();
      const url = window.URL.createObjectURL(new Blob([buffer]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', image?.fields.file.fileName);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      logger.error(err);
    }
  };

  const shareImage = async (e: any) => {
    e.preventDefault();
    const { image } = props;
    const imageSrc = `https:${image?.fields.file.url}`;
    const response = await fetch(imageSrc.toString());
    const blob = await response.blob();
    const fileName = image?.fields.file.fileName;
    const filesArray = [
      new File([blob], fileName, {
        type: 'image/png',
        lastModified: Date.now(),
      }),
    ];
    // const shareData = {
    //   url: 'instagram-stories://share',
    // };
    try {
      if (navigator.canShare && navigator.canShare({ files: filesArray })) {
        await navigator.share({ files: filesArray });
        return null;
      }
    } catch (err) {
      return null;
    }
    return null;
  };
  return (
    <div className={`has-text-centered ${styles.skillbuilderSubmissionPopUp}`}>
      <div className={clsx(styles.section)}>
        <Typo h2>
          {heading}, {appUser?.first_name}!
        </Typo>
        <Typo classes="mb-5" h3>
          You did well! Share this image on Instagram and tag @knopro_org to win $50!
        </Typo>
        <Typo classes="mb-5" h4>
          Please do not share during class!
        </Typo>
      </div>
      <Image
        src={imageSrc}
        loader={utils.imageLoader}
        width={400}
        height={400}
        alt={image?.fields.description}
      />
      {/* @ts-expect-error navigator.canShare is a real method, but linter does not know it */}
      {navigator.canShare && (
        <a
          className={styles.downloadButton}
          href={'instagram-stories://share'}
          onClick={e => shareImage(e)}
        >
          <Image
            src={shareIcon}
            className={styles.shareIcon}
            alt="Share Icon"
            width="30"
            height="30"
            loader={utils.imageLoader}
          />
          Share
        </a>
      )}
      <a className={styles.downloadButton} href={imageSrc} download onClick={e => download(e)}>
        <Image
          src={downloadIcon}
          className={styles.downloadIcon}
          alt="Download Icon"
          width="30"
          height="30"
          loader={utils.imageLoader}
        />
        <i className="fa fa-download" />
        Download Image
      </a>
      <div className={clsx('is-bgcolor-Grey', styles.section)}>
        {description && (
          <div className={styles.bodyContent}>
            <RichText document={description} />
          </div>
        )}
      </div>
      <div className={clsx(styles.section)}>{footer && <RichText document={footer} />}</div>
    </div>
  );
};

export default SkillbuilderSubmissionPopUp;
